import { useTheme } from "../../contexts/ThemeContext";

// Wrapper visual para inputs/selects/textareas dentro dos modais.
// Usa as mesmas variáveis de tema (bordas, inputBg, textMuted).

export function fieldInputStyle(C) {
  return {
    width: "100%",
    padding: "11px 14px",
    borderRadius: 10,
    border: `1px solid ${C.border}`,
    background: C.inputBg,
    color: C.text,
    fontSize: 13,
    outline: "none",
    fontFamily: "'DM Sans', sans-serif",
    boxSizing: "border-box",
  };
}

export default function FormField({
  label,
  children,
  required = false,
  hint,
  span = 1,
}) {
  const { C } = useTheme();
  return (
    <div style={{ gridColumn: `span ${span}` }}>
      <label
        style={{
          fontSize: 11,
          fontWeight: 600,
          color: C.textMuted,
          display: "block",
          marginBottom: 6,
          textTransform: "uppercase",
          letterSpacing: 0.5,
        }}
      >
        {label} {required && <span style={{ color: C.red }}>*</span>}
      </label>
      {children}
      {hint && (
        <div style={{ fontSize: 10, color: C.textDim, marginTop: 4 }}>{hint}</div>
      )}
    </div>
  );
}

export function FormActions({
  onCancel,
  onDelete,
  saving,
  submitLabel = "Salvar",
  deleteLabel = "Excluir",
  // Override opcional do background do botão submit. Se omitido, usa o
  // gradient accent padrão (caller existente não quebra).
  submitBackground,
  // Slot opcional pra uma ação secundária (ex.: "Imprimir Dia") posicionada
  // à esquerda de Cancelar. Estilo neutro pra não competir com o submit.
  // Se onPrint não é passado, o botão não renderiza — callers existentes
  // não veem diferença.
  onPrint,
  printLabel = "Imprimir",
  printDisabled = false,
  printTitle,
}) {
  const { C, isDark } = useTheme();
  const submitBg = submitBackground ?? `linear-gradient(135deg, ${C.accent}, ${C.accentLight})`;
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 10,
        marginTop: 22,
        paddingTop: 18,
        borderTop: `1px solid ${C.border}`,
      }}
    >
      <div>
        {onDelete && (
          <button
            type="button"
            onClick={onDelete}
            disabled={saving}
            style={{
              padding: "10px 16px",
              borderRadius: 10,
              border: `1px solid ${C.red}60`,
              background: "transparent",
              color: C.red,
              fontSize: 13,
              fontWeight: 600,
              cursor: saving ? "not-allowed" : "pointer",
              fontFamily: "'DM Sans', sans-serif",
            }}
          >
            🗑 {deleteLabel}
          </button>
        )}
      </div>
      <div style={{ display: "flex", gap: 10 }}>
        {onPrint && (
          <button
            type="button"
            onClick={onPrint}
            disabled={saving || printDisabled}
            title={printTitle}
            style={{
              padding: "10px 16px",
              borderRadius: 10,
              border: `1px solid ${C.border}`,
              background: "transparent",
              color: C.textMuted,
              fontSize: 13,
              fontWeight: 600,
              cursor: saving || printDisabled ? "not-allowed" : "pointer",
              opacity: printDisabled ? 0.5 : 1,
              fontFamily: "'DM Sans', sans-serif",
            }}
          >
            {printLabel}
          </button>
        )}
        <button
          type="button"
          onClick={onCancel}
          disabled={saving}
          style={{
            padding: "10px 18px",
            borderRadius: 10,
            border: `1px solid ${C.border}`,
            background: "transparent",
            color: C.textMuted,
            fontSize: 13,
            fontWeight: 600,
            cursor: saving ? "not-allowed" : "pointer",
            fontFamily: "'DM Sans', sans-serif",
          }}
        >
          Cancelar
        </button>
        <button
          type="submit"
          disabled={saving}
          style={{
            padding: "10px 22px",
            borderRadius: 10,
            border: "none",
            background: submitBg,
            color: isDark ? "#0B1219" : "#fff",
            fontSize: 13,
            fontWeight: 700,
            cursor: saving ? "wait" : "pointer",
            opacity: saving ? 0.7 : 1,
            fontFamily: "'DM Sans', sans-serif",
          }}
        >
          {saving ? "Salvando..." : submitLabel}
        </button>
      </div>
    </div>
  );
}
